/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Report summary statistics */
export type ReportSummary = {
  /** Total transactions */
  totalTransactions: bigint;
  /** Total volume */
  totalVolume: bigint;
  /** High-risk transactions */
  highRiskTransactions: bigint;
  /** Compliance violations */
  complianceViolations: bigint;
  /** Security incidents */
  securityIncidents: bigint;
  /** Average risk score */
  averageRiskScore: number;
};

export type ReportSummaryArgs = {
  /** Total transactions */
  totalTransactions: number | bigint;
  /** Total volume */
  totalVolume: number | bigint;
  /** High-risk transactions */
  highRiskTransactions: number | bigint;
  /** Compliance violations */
  complianceViolations: number | bigint;
  /** Security incidents */
  securityIncidents: number | bigint;
  /** Average risk score */
  averageRiskScore: number;
};

export function getReportSummaryEncoder(): FixedSizeEncoder<ReportSummaryArgs> {
  return getStructEncoder([
    ["totalTransactions", getU64Encoder()],
    ["totalVolume", getU64Encoder()],
    ["highRiskTransactions", getU64Encoder()],
    ["complianceViolations", getU64Encoder()],
    ["securityIncidents", getU64Encoder()],
    ["averageRiskScore", getU8Encoder()],
  ]);
}

export function getReportSummaryDecoder(): FixedSizeDecoder<ReportSummary> {
  return getStructDecoder([
    ["totalTransactions", getU64Decoder()],
    ["totalVolume", getU64Decoder()],
    ["highRiskTransactions", getU64Decoder()],
    ["complianceViolations", getU64Decoder()],
    ["securityIncidents", getU64Decoder()],
    ["averageRiskScore", getU8Decoder()],
  ]);
}

export function getReportSummaryCodec(): FixedSizeCodec<
  ReportSummaryArgs,
  ReportSummary
> {
  return combineCodec(getReportSummaryEncoder(), getReportSummaryDecoder());
}
